module.exports=[
  {
    "specifics": "\"Angered after being detained at Fort Lewis\"",
    "highlight": "\"Angered after being detained at Fort Lewis\"",
    "svg": "LI-1",
    "final_category": "Lack of information/underreporting",
    "caption_popup": "It is unclear if Jane Fonda said she was angry. Today, we avoid ascribing emotional or mental states to others. We allow them to speak for themselves through quotations or by indicating how they feel."
  },
  {
    "specifics": "\"Miss Fonda was present at Fort Lawton yesterday when more than 100 Indians tried to 'take over' the fort\"",
    "highlight": "\"when more than 100 Indians tried to 'takeover the fort\"",
    "svg": "LI-2",
    "final_category": "Lack of information/underreporting",
    "caption_popup": "\"Take over\" appears to be a quotation, but it's not attributed to anyone.\n"
  },
  {
    "specifics": "Headline: Jane Fonda 'gripes\" about detention at Fort Lewis",
    "highlight": "\"gripes\"",
    "svg": "IL-1",
    "final_category": "Inaccurate language",
    "caption_popup": "The headline takes \"gripes\" out of context; Fonda said she asked Fort Lewis soldiers to \"tell me about their gripes.\" \n"
  },
  {
    "specifics": "topmost story about the occupation is about Jane Fonda's experience being detained",
    "highlight": "\"Miss Fonda was present at Fort Lawton yesterday\"",
    "svg": "SF-1",
    "final_category": "Story framing/focus (bias)",
    "caption_popup": "A visiting celebrity is given more prominence than the local people whose movement she was supporting. Using today's standards, this story would be on an inside page or folded into a more complete story about the occupation."
  }
]